
<form  #form="ngForm">
    @for (documentType of formDocumentTypes(); let idx = $index; track $index) {
        <app-layout-row>
                <app-layout-column [width]="12">
                    <div class="inputandmessage-container">
                        <div class="typeandvalue">
                            <app-checkbox [name]="'selectedDocumentType-' + documentType.Id" [caption]="documentType.Name" [ngModel]="documentType.Selected" [readonly]="isReadOnly(documentType)"></app-checkbox>
                            <div class="valueandcomment">
                                <app-singleselectbox 
                                    [name]="'documentTypeFormat-' + documentType.Id" 
                                    caption="Format" 
                                    [ngModel]="$safeNavigationMigration(documentType.SelectedFormat?.Id)"
                                    [dataSource]="documentType.PossibleFormats" 
                                    valueExpr="Id" 
                                    displayExpr="Name" 
                                    [disabled]="isDisabled(documentType)"
                                    [readonly]="isReadOnly(documentType)"
                                    [itemTemplate]="itemTemplate" 
                                    [autoSort]="false"
                                    required>
                                    <ng-template #itemTemplate let-data>
                                        @if (data.Name === 'Other') {
                                            <div><i>{{data.Name}}</i></div>
                                        }
                                        @else {
                                            <div>{{data.Name}}</div>
                                        }
                                    </ng-template>
                                </app-singleselectbox>
                                @if (!isCustomFormat('documentTypeFormat-' + $safeNavigationMigration(documentType?.Id))) {
                                    <app-onboarding-comments-icon [disabled]="!allowConversation() || isDisabled(documentType) || !hasConversationId(documentType)" (clicked)="toggleConversation($safeNavigationMigration(documentType?.ConversationId), null)" [hasUnreadMessages]="hasUnreadMessages($safeNavigationMigration(documentType?.ConversationId))"></app-onboarding-comments-icon>
                                }
                            </div>
                        </div>
                        @if (documentType?.ConversationId && documentType?.ConversationId===conversationToShow()?.Id && !isCustomFormat('documentTypeFormat-' + $safeNavigationMigration(documentType?.Id))) {
                            <app-onboarding-comments-container title="Comments" [autoRefreshEnabled]="autoRefreshEnabled()" (toggleAutoRefreshClicked)="toggleAutoRefresh()" (closeClicked)="toggleConversation($safeNavigationMigration(documentType?.ConversationId), null)">
                                <app-conversation [conversation]="conversationToShow()" [readonly]="readonlyConversation()" (postNewMessageClicked)="newComment($event, $safeNavigationMigration(conversationToShow()?.Id))"></app-conversation>
                            </app-onboarding-comments-container>
                        }
                    </div>
                </app-layout-column>
        </app-layout-row>
        @if (isCustomFormat('documentTypeFormat-' + documentType.Id)) {
            <app-layout-row>
                <app-layout-column [width]="12">
                    <div class="inputandmessage-container">
                        <div class="typeandvalue">
                            <p></p>
                            <div class="valueandcomment">
                                <app-textbox [name]="'customDocumentTypesFormat-' + documentType.Id" caption="Other Format" [ngModel]="documentType.CustomFormatName" required [readonly]="isReadOnly(documentType)"></app-textbox>
                                <app-onboarding-comments-icon [disabled]="!allowConversation() || !hasConversationId(documentType)" (clicked)="toggleConversation($safeNavigationMigration(documentType?.ConversationId), null)" [hasUnreadMessages]="hasUnreadMessages($safeNavigationMigration(documentType?.ConversationId))"></app-onboarding-comments-icon>
                            </div>
                        </div>
                        @if (documentType?.ConversationId && documentType?.ConversationId===conversationToShow()?.Id) {
                            <app-onboarding-comments-container title="Comments" [autoRefreshEnabled]="autoRefreshEnabled()" (toggleAutoRefreshClicked)="toggleAutoRefresh()" (closeClicked)="toggleConversation($safeNavigationMigration(documentType?.ConversationId), null)">
                                <app-conversation [conversation]="conversationToShow()" [readonly]="readonlyConversation()" (postNewMessageClicked)="newComment($event, $safeNavigationMigration(conversationToShow()?.Id))"></app-conversation>
                            </app-onboarding-comments-container>
                        }
                    </div>
                </app-layout-column>
            </app-layout-row>
        }

        <app-layout-row>
            <app-layout-column [width]="12">
                <div class="inputandmessage-container">
                    <div class="typeandvalue">
                        <p></p>
                        <div class="transport-configuration">
                            <app-onboarding-transport 
                                [name]="'documentTypeTransport-' + documentType.Id" 
                                [ngModel]="documentType.Transport" 
                                [possibleTransports]="possibleTransportTypes()" 
                                [documentDirection]="documentDirection()" 
                                [readonly]="isReadOnly(documentType)" 
                                [disabled]="isDisabled(documentType)"
                                [readonlyConversation]="readonlyConversation()"
                                [allowConversation]="allowConversation()"
                                [conversation]="conversation()"
                                [autoRefreshEnabled]="autoRefreshEnabled()" 
                                [unreadConversationIds]="unreadConversationIds()"
                                (toggleConversationClicked)="toggleConversation($event.ConversationId, $event.AreaId)"
                                (toggleAutoRefreshClicked)="toggleAutoRefresh()"
                                (newCommentClicked)="newTransportComment($event)" 
                                (requestCredentialsClicked)="requestCredentials($event)"
                                (showCredentialsClicked)="showCredentials($event)"
                                [conversationAreaId]="'documentTypeTransport-' + documentType.Id">
                            </app-onboarding-transport>
                        </div>
                    </div>
                </div>
            </app-layout-column>
        </app-layout-row>
    }

    @for (customDocumentType of formCustomDocumentTypes(); let idx = $index; track $index) {
        <app-layout-row>
                <app-layout-column [width]="12">
                    <div class="inputandmessage-container">
                        <div class="customtypeandvalue">
                            <app-textbox [name]="'customDocumentTypesName-' + idx" [caption]="'Document Type'" [(ngModel)]="customDocumentType.Name" required [readonly]="isReadOnly(customDocumentType)"></app-textbox>
                            <app-textbox [name]="'customDocumentTypesValue-' + idx" caption="Format" [(ngModel)]="customDocumentType.Format" required [readonly]="isReadOnly(customDocumentType)"></app-textbox>
                            <app-link iconClass="dx-icon-trash" (onClick)="removeCustomDocumentTypes(idx)" [disabled]="isReadOnly(customDocumentType)"></app-link>
                            <app-onboarding-comments-icon [disabled]="!allowConversation() || !hasConversationId(customDocumentType)" (clicked)="toggleConversation($safeNavigationMigration(customDocumentType?.ConversationId), null)" [hasUnreadMessages]="hasUnreadMessages($safeNavigationMigration(customDocumentType?.ConversationId))"></app-onboarding-comments-icon>
                        </div>
                        @if (customDocumentType?.ConversationId && customDocumentType?.ConversationId===conversationToShow()?.Id) {
                            <app-onboarding-comments-container title="Comments" [autoRefreshEnabled]="autoRefreshEnabled()" (toggleAutoRefreshClicked)="toggleAutoRefresh()" (closeClicked)="toggleConversation($safeNavigationMigration(customDocumentType?.ConversationId), null)">
                                <app-conversation [conversation]="conversationToShow()" [readonly]="readonlyConversation()" (postNewMessageClicked)="newComment($event, $safeNavigationMigration(conversationToShow()?.Id))"></app-conversation>
                            </app-onboarding-comments-container>
                        }
                    </div>
                </app-layout-column>
        </app-layout-row>
        <app-layout-row>
            <app-layout-column [width]="12">
                <div class="inputandmessage-container">
                    <div class="typeandvalue">
                        <p></p>
                        <div class="transport-configuration">
                            <app-onboarding-transport 
                                [name]="'customDocumentTypesTransport-' + idx" 
                                [ngModel]="customDocumentType.Transport" 
                                [possibleTransports]="possibleTransportTypes()" 
                                [documentDirection]="documentDirection()" 
                                [readonly]="isReadOnly(customDocumentType)" 
                                [disabled]="isReadOnly(customDocumentType)"
                                [readonlyConversation]="readonlyConversation()"
                                [allowConversation]="allowConversation()"
                                [conversation]="conversation()" 
                                [unreadConversationIds]="unreadConversationIds()"
                                (toggleConversationClicked)="toggleConversation($event.ConversationId, $event.AreaId)" 
                                (newCommentClicked)="newTransportComment($event)" 
                                (requestCredentialsClicked)="requestCredentials($event)"
                                (showCredentialsClicked)="showCredentials($event)"
                                [conversationAreaId]="'customDocumentTypesTransport-' + idx">
                            </app-onboarding-transport>
                        </div>
                    </div>
                </div>
            </app-layout-column>
        </app-layout-row>
    }

<app-layout-row>
  <app-layout-column [width]="12">
    @if (formCustomDocumentTypes().length === 0) {
      <p>Your document type is not on the list?</p>
    }
    <app-link iconClass="dx-icon-add" (onClick)="addCustomDocumentTypes()" [disabled]="readonly()">Add Additional Document Type</app-link>
  </app-layout-column>
</app-layout-row>
</form>